{
  "BULK_ACTION": {
    "CONVERSATIONS_SELECTED": "{conversationCount} converses seleccionades",
    "NONE": "Ningú",
    "CLEAR_SELECTION": "Neteja",
    "ASSIGN_AGENT_CONFIRMATION_LABEL": "Are you sure you want to assign {n} conversation to {agentName}? | Are you sure you want to assign {n} conversations to {agentName}?",
    "UNASSIGN_AGENT_CONFIRMATION_LABEL": "Are you sure you want to unassign {n} conversation? | Are you sure you want to unassign {n} conversations?",
    "YES": "Si",
    "CANCEL": "Cancel·la",
    "SEARCH_INPUT_PLACEHOLDER": "Cercar",
    "ASSIGN_AGENT_TOOLTIP": "Assigna un agent",
    "ASSIGN_TEAM_TOOLTIP": "Assigna un equip",
    "ASSIGN_SUCCESFUL": "Les converses s'han assignat correctament.",
    "ASSIGN_FAILED": "No s'han pogut assignar les converses. Torna-ho a provar.",
    "RESOLVE_SUCCESFUL": "Les converses s'han resolt correctament.",
    "RESOLVE_FAILED": "No s'han pogut resoldre les converses. Torna-ho a provar.",
    "ALL_CONVERSATIONS_SELECTED_ALERT": "Les converses visibles en aquesta pàgina només estan seleccionades.",
    "UPDATE": {
      "CHANGE_STATUS": "Canvia l'estat",
      "SNOOZE_UNTIL": "Posposat",
      "UPDATE_SUCCESFUL": "L'estat de les converses s'ha actualitzat correctament.",
      "UPDATE_FAILED": "No s'han pogut actualitzar les converses. Torna-ho a provar."
    },
    "RESOLVE": {
      "ALL_MISSING_ATTRIBUTES": "Cannot resolve conversations due to missing required attributes",
      "PARTIAL_SUCCESS": "Some conversations need required attributes before resolving and were skipped"
    },
    "LABELS": {
      "ASSIGN_LABELS": "Assignar etiquetes",
      "REMOVE_LABELS": "Remove labels",
      "ASSIGN_SELECTED_LABELS": "Assigna les etiquetes seleccionades",
      "REMOVE_SELECTED_LABELS": "Remove selected labels",
      "ASSIGN_SUCCESFUL": "L'etiqueta s'ha assignat correctament.",
      "ASSIGN_FAILED": "No s'han pogut assignar les etiquetes. Torna-ho a provar.",
      "REMOVE_SUCCESFUL": "Labels removed successfully.",
      "REMOVE_FAILED": "Failed to remove labels. Please try again."
    },
    "TEAMS": {
      "NONE": "Ningú",
      "ASSIGN_TEAM_CONFIRMATION_LABEL": "Are you sure you want to assign {n} conversation to {teamName}? | Are you sure you want to assign {n} conversations to {teamName}?",
      "UNASSIGN_TEAM_CONFIRMATION_LABEL": "Are you sure you want to unassign {n} conversation? | Are you sure you want to unassign {n} conversations?",
      "ASSIGN_SUCCESFUL": "Equips assignats correctament.",
      "ASSIGN_FAILED": "No s'han pogut assignar els equips. Torna-ho a provar."
    }
  }
}
